import { WisselDeelOpdracht } from '@/queries/mutaties/opdrachten';
import { Overgang } from '@/types/deeltrajecten';

import { MwdOvergang } from '../types/Domain';
import { MwdGeslotenWisselRequest, MwdOpenWisselRequest } from '../types/Mutaties';

export const deelOpdracht = (): WisselDeelOpdracht => {
  return {};
};

/**
 * Despite the source data being the same in v1 and v2, there might be differences in how mutations are formulated in v2.
 */
export const geslotenWisselRequest = (
  overgangen: [MwdOvergang | Overgang, MwdOvergang | Overgang],
): MwdGeslotenWisselRequest => {
  const [firstOvergang, secondOvergang] = overgangen;
  return {
    deelOpdrachten: [
      {
        vanafWerklijn: firstOvergang.werklijnId,
        vanafNaInzet: firstOvergang.naInzetId,
        naarWerklijn: secondOvergang.werklijnId,
        naarNaInzet: secondOvergang.naInzetId,
      },
      {
        vanafWerklijn: secondOvergang.werklijnId,
        vanafNaInzet: secondOvergang.naInzetId,
        naarWerklijn: firstOvergang.werklijnId,
        naarNaInzet: firstOvergang.naInzetId,
      },
    ],
    betrokkenWerklijnen: [
      {
        id: firstOvergang.werklijnId,
        versie: firstOvergang.werklijnVersie,
      },
      {
        id: secondOvergang.werklijnId,
        versie: secondOvergang.werklijnVersie,
      },
    ],
  };
};

export const openWisselRequest = (overgang: MwdOvergang): MwdOpenWisselRequest => {
  return {
    deelOpdrachten: [
      {
        vanafWerklijn: overgang.werklijnId,
        vanafNaInzet: overgang.naInzetId,
      },
    ],
    betrokkenWerklijnen: [
      {
        id: overgang.werklijnId,
        versie: overgang.werklijnVersie,
      },
    ],
  };
};
